import styles from "./CompanyBenefits.module.scss";
import { useTranslation } from "next-i18next";
import { H1, P2 } from "@/lib/ui/components/Typography";
import cl from "classnames";
import Image from "next/image";
import { FC } from "react";
import { apartmentsLandingBenefits, benefits, propertymanagement, rentLanding, villaLandingBenefits } from "./constants";

interface ICompanyBenefits {
  disableBackground?: boolean;
  isVillasLanding?: boolean;
  isApartmentsLanding?: boolean;
  isPropertyManagement?: boolean;
  isRentLanding?: boolean;
  removeLeaf?: boolean;
  className?: string;
  isWideText?: boolean;
  theme?: "light" | "dark";
  title?: string;
}

export const CompanyBenefits: FC<ICompanyBenefits> = ({
  disableBackground,
  isVillasLanding,
  isApartmentsLanding,
  isPropertyManagement,
  isRentLanding,
  removeLeaf,
  className,
  isWideText,
  theme = 'dark',
  title = "benefits"
}) => {
  const { t } = useTranslation("index", { keyPrefix: "about" });

  const items = 
    isVillasLanding ? villaLandingBenefits : 
    isApartmentsLanding ? apartmentsLandingBenefits : 
    isPropertyManagement ? propertymanagement : 
    isRentLanding ? rentLanding 
    : benefits;

  return (
    <div
      id="benefits"
      className={cl(
        styles.benefits,
        !disableBackground && styles["benefits--bg"],
        theme === 'light' && styles["benefits--light"],
        isPropertyManagement && styles["benefits--mobGray"],
        isRentLanding && styles["benefits--rent"],
        className,
      )}
    >
      {!removeLeaf && (
        <div className={styles.benefits_imageWrapper}>
          <Image
            // sizes="(max-width: 768px) 100vw, 0vw"
            sizes="522px"
            className={styles.benefits_leaf}
            src={"/images/complex/leaf/blue-leaf.webp"}
            fill
            alt=""
          />
        </div>
      )}

      <div className={styles.container}>
        <H1 
          as={'h2'} 
          className={cl(styles.benefits_title, (isPropertyManagement || isRentLanding) && styles["benefits_title--left"])}
        >{t(title)}</H1>
        <ul
          className={cl(
            styles.benefits_list,
            isVillasLanding && styles["benefits_list--four"],
            isPropertyManagement && styles["benefits_list--smallGap"],
            isRentLanding && styles["benefits_list--three"],
          )}
        >
          {items.map((item) => (
            <li
              key={item.title}
              className={cl(
                styles.benefits_item,
                isWideText && styles["benefits_item--wide"],
                isPropertyManagement && styles["benefits_item--wide--super"],
                isRentLanding && styles["benefits_item--three"],
              )}
            >
              <h2 className={cl(
                styles.benefits_item_title,
                theme === 'light' ? styles["benefits_item_title--light"] : styles["benefits_item_title--dark"],
                )}
                >{t(item.title)}</h2>
              <P2>{t(item.text)}</P2>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
